export const defaultSilhouetteUrl = 'https://cdn.xsd.cz/resize/4ed1ce460ee73c2496b6a32b8a9cb872_extract=0,0,600,600_resize=200,200_.png?hash=205b3e74ec53e256b897a23eb179460b'
